"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utiliser sur les input qui doivent déclencher des predicats
 */
exports.default = {
    updated: function updated() {
        this.predicateChange();
    },
    methods: {
        getPredicateValue: function getPredicateValue() {
            return this.value;
        },
        predicateChange: function predicateChange() {
            this.$root.$emit("predicate-change", {
                name: this.name,
                value: this.getPredicateValue()
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/PredicateInput.ts
// module id = 23
// module chunks = 0